var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 24",
    style: {
      enableBackground: "new 0 0 48 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#767676;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{fill:#036635;stroke:#036635;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21,11.5c0,1.3-0.3,2.6-0.9,3.8c-0.7,1.4-1.8,2.6-3.1,3.4c-1.3,0.8-2.9,1.3-4.5,1.3c-1.3,0-2.6-0.3-3.8-0.9 L3,21l1.9-5.7C4.3,14.1,4,12.8,4,11.5C4,9.9,4.4,8.4,5.3,7s2-2.4,3.4-3.1C9.9,3.3,11.2,3,12.5,3H13c2.1,0.1,4.1,1,5.5,2.5 C20,6.9,20.9,8.9,21,11V11.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45,11.5c0,1.3-0.3,2.6-0.9,3.8c-0.7,1.4-1.8,2.6-3.1,3.4c-1.3,0.8-2.9,1.3-4.5,1.3c-1.3,0-2.6-0.3-3.8-0.9 L27,21l1.9-5.7c-0.6-1.2-0.9-2.5-0.9-3.8c0-1.6,0.4-3.1,1.3-4.5s2-2.4,3.4-3.1C33.9,3.3,35.2,3,36.5,3H37c2.1,0.1,4.1,1,5.5,2.5 C44,6.9,44.9,8.9,45,11V11.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon-chat.e3c21c98fd6e3daedc22b50d5ad6898b.svg";
export { ForwardRef as ReactComponent };